var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("ul", { staticClass: "list-group list-group-flush" }, [
        _c(
          "li",
          { staticClass: "list-group-item" },
          [
            _c("b-skeleton", {
              staticClass: "mt-2",
              attrs: { animation: "fade", width: "20%" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "list-group-item" }, [
          _c("div", { staticClass: "mx-0 col-lg-10" }, [
            _c("div", { staticClass: "row moregage-form" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("b-skeleton", {
                    staticClass: "mt-2",
                    attrs: { animation: "fade", width: "50%" },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row moregage-form" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group-material" },
                  [
                    _c("b-skeleton", {
                      staticClass: "mt-2",
                      attrs: { animation: "fade", width: "50%" },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row moregage-form align-items-center" }, [
              _c("div", { staticClass: "col" }, [
                _c(
                  "div",
                  { staticClass: "form-group-material" },
                  [
                    _c("b-skeleton", {
                      staticClass: "mt-2",
                      attrs: { animation: "fade", width: "50%" },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }